(function() {
    'use strict';

    angular
        .module('mVtasWebApp')
        .controller('VentamesDeleteController',VentamesDeleteController);

    VentamesDeleteController.$inject = ['$uibModalInstance', 'entity', 'Ventames'];

    function VentamesDeleteController($uibModalInstance, entity, Ventames) {
        var vm = this;

        vm.ventames = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Ventames.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
